import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_AD_45 } from "@/lib/programData";
export default function AtlasDesierto45Page() {
  return <ProgramTemplate program={PROGRAM_AD_45} variant="ad" showJourneyChronology />;
}
